import { render, staticRenderFns } from "./UiPostInteractions.vue?vue&type=template&id=7b32fdad&"
import script from "./UiPostInteractions.vue?vue&type=script&lang=js&"
export * from "./UiPostInteractions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports